import HttpServices from './index';

class AuthService extends HttpServices {
  getUserData = () => this.http.get('/users/current');
}

export default new AuthService();
